import { connectStateResults, Highlight, Hits, InstantSearch, Pagination, PoweredBy, SearchBox } from 'react-instantsearch-dom';
import React, { useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import StateResults from './StateResults';

const algoliaClientForIt = algoliasearch('RU927AJP42', '502ec563646646e6c24f4f9d4352ad51');


// fix initial query with empty parameters
// https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react/
// https://codesandbox.io/s/github/algolia/doc-code-samples/tree/master/React%20InstantSearch/conditional-request?file=/src/App.js:255-292
const searchClientForIt = {
  search (requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          processingTimeMS: 0,
        })),
      });
    }

    return algoliaClientForIt.search(requests);
  },
};

function HitForIt (props) {

  const [ isAdditionalWordsExpanded, setAdditionalWordsExpanded ] = useState(false);

  return (
    <article>
      <p className="hit__text hit__text--it">
        <Highlight attribute="text_it" hit={props.hit} />
      </p>
      <p className="hit__text hit__text--fr">
        <Highlight attribute="text_src" hit={props.hit} />
      </p>
      {(props.hit.additional_keywords_it || props.hit.additional_keywords_src) && <aside>
        <button onClick={() => {setAdditionalWordsExpanded(!isAdditionalWordsExpanded);}}
                className={`hit__additional-keywords__btn ${isAdditionalWordsExpanded ? 'hit__additional-keywords__btn--expanded' : ''}`}>{'>'}</button>
        <div className={`hit__additional-keywords ${isAdditionalWordsExpanded ? 'hit__additional-keywords--expanded' : 'hit__additional-keywords--reduced'}`}>
          <p className="hit__additional-keywords--it">
            <Highlight attribute="additional_keywords_it" hit={props.hit} />
          </p>
          <p className="hit__additional-keywords--fr">
            <Highlight attribute="additional_keywords_src" hit={props.hit} />
          </p>
        </div>
      </aside>
      }
    </article>
  );
}

const CustomStateResults = connectStateResults(StateResults);

export default function AppIt () {
  return (
    <main className="app-it">
      <h2 className={'visually-hidden'}>App It</h2>
      <section className="ais-InstantSearch">
        <InstantSearch indexName="dev_it" searchClient={searchClientForIt}>
          <SearchBox showLoadingIndicator autoFocus searchAsYouType={false} />
          <CustomStateResults />
          <Hits hitComponent={HitForIt} />
          <Pagination />
          <PoweredBy />
        </InstantSearch>
      </section>
    </main>
  );
}

